import React from 'react';
import { useInternationalisation } from '../../internationalisation/hooks/useInternationalisation';
import { SearchPlaceholder } from '../../infrastructure/interface/components/SearchPlaceholder';

export const ReportsPlaceholder = () => {
  const { translate } = useInternationalisation();

  return <SearchPlaceholder message={translate('pages.reports.placeholderMessage')} />;
};
